<div class="member-details-container" fxLayout="column">
    <div fxLayout="row" fxLayoutGap="100px" *ngIf="member">

        <!-- property units and pods left column -->
        <div fxLayout="column" fxLayoutGap="30px">

            <!-- property units -->
            <ng-container *ngFor="let propertyUnit of member.property_units">
                <ng-container *appVar="getPropertyUnitRelations(propertyUnit.id) as propertyUnitRelations">
                    <div *ngIf="propertyUnitRelations.length && showPropertyUnit(propertyUnit)" fxLayout="column" class="pod-panel" fxLayoutGap="8px">
                        <div class="field-name">{{ 'Owned property unit'|i18n }}</div>
                        <div class="mt-12 ml-16" fxLayout="row" fxLayoutGap="4px">
                            <div class="field-name">{{ 'Land registry data'|i18n }}:</div>
                            <div>{{ mkLandRegistryDataString(propertyUnit) }}</div>
                        </div>
                        <div class="mt-12 ml-16" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="18px">
                            <div [fxFlexAlign]="propertyUnitRelations.length > 1 ? 'start' : 'auto'"
                                 class="field-name">{{ 'Role'|i18n }}:
                            </div>
                            <div fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="8px">
                                <div *ngFor="let relation of propertyUnitRelations"
                                     fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px">
                                    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="8px" class="chip pod-owner">
                                        <app-icon name="fal-key"></app-icon>
                                        <span class="text">{{ 'Owner'|i18n }}</span>
                                    </div>
                                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" class="date-range">
                                        <div *ngIf="isDefined(relation.start_date)">
                                            {{ 'From {0}__{date}'|i18n:(relation.start_date|i18nDate) }}
                                        </div>
                                        <div *ngIf="isDefined(relation.end_date)">
                                            {{ 'to {0}__{date}'|i18n:(relation.end_date|i18nDate) }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </ng-container>

            <!-- pods -->
            <div *ngFor="let pod of member.pods; let i=index">
                <div fxLayout="column" class="pod-panel" fxLayoutGap="8px">
                    <ng-container *ngIf="mkLandRegistryDataString(pod.land_registry_data) as lrd">
                        <div class="field-name">{{ 'Property unit related to POD'|i18n }}</div>
                        <div class="mt-12 ml-16" fxLayout="row" fxLayoutGap="4px">
                            <div class="field-name">{{ 'Land registry data'|i18n }}:</div>
                            <div>{{ lrd }}</div>
                        </div>
                    </ng-container>
                    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="50px" class="mt-12">
                        <div fxLayout="row">
                            <div class="mr-10" fxLayout="row" fxLayoutGap="4px">
                                <span class="field-name">{{ 'POD {0}'|i18n:(i + 1) }}:</span>
                                <span>{{ pod.pod }}</span>
                            </div>
                        </div>
                        <div fxLayout="row" fxLayoutGap="4px">
                            <button [disabled]="!hasResource(pod.pod)" *ngIf="hasResource(pod.pod)" (click)="navigateToEntity(pod.pod)"
                                    app-small-ghost-button>
                                <app-icon name="fal-sitemap"></app-icon>
                                <app-icon name="fal-arrow-right" class="no-margin"></app-icon>
                            </button>
                        </div>
                    </div>
                    <div *ngIf="podProfileInfo[pod.pod] as profInfo" class="mt-12 ml-16"
                         fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="18px">
                        <div class="field-name">{{ 'Profile'|i18n }}:</div>
                        <div fxLayout="row" fxLayoutGap="8px">
                            <div class="chip"
                                 [ngClass]="'energy-profile-'+mkPodProfileClass(profInfo.profile)"
                                 fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="8px">
                                <app-icon *ngIf="profInfo.icon" [name]="profInfo.icon"></app-icon>
                                <span class="aspiring-text">{{ (profInfo.name || '-')|i18n }}</span>
                            </div>
                            <div *ngIf="pod.aspiring_prosumer"
                                 class="chip energy-profile-aspiring_prosumer"
                                 fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="8px">
                                <app-icon name="fal-telescope"></app-icon>
                                <span class="text">{{ 'Aspiring prosumer'|i18n }}</span>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="pod.pod_utility_type" class="mt-12 ml-16" fxLayout="row" fxLayoutGap="4px">
                        <span class="field-name">{{ 'Type of utility'|i18n }}:</span>
                        <span>{{ (pod.pod_utility_type|genericPipe)|i18n }}</span>
                    </div>
                    <div class="mt-12 ml-16" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="18px"
                         *appVar="getPodRelations(pod.pod) as podRelations">
                        <div [fxFlexAlign]="podRelations.length > 1 ? 'start' : 'auto'"
                             class="field-name">{{ 'Role'|i18n }}:
                        </div>
                        <div fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="8px">
                            <div *ngFor="let relation of podRelations"
                                 fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px">
                                <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="8px" class="chip pod-holder">
                                    <app-icon name="fal-lightbulb"></app-icon>
                                    <span class="text">{{ 'Holder'|i18n }}</span>
                                </div>
                                <div *ngIf="showAllRoles(member)" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="8px" class="chip pod-owner">
                                    <app-icon name="fal-key"></app-icon>
                                    <span class="text">{{ 'Owner'|i18n }}</span>
                                </div>
                                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" class="date-range">
                                    <div *ngIf="isDefined(relation.start_date)">
                                        {{ 'From {0}__{date}'|i18n:(relation.start_date|i18nDate) }}
                                    </div>
                                    <div *ngIf="isDefined(relation.end_date)">
                                        {{ 'to {0}__{date}'|i18n:(relation.end_date|i18nDate) }}
                                    </div>
                                </div>
                                <ng-container *appVar="isPodActive(relation) as podActive">
                                    <div *ngIf="podActive" class="active-pod">
                                        <app-icon name="fal-check-circle"></app-icon>
                                        {{ 'GSE active'|i18n }}
                                    </div>
                                    <div *ngIf="!podActive" class="inactive-pod">
                                        <app-icon name="fal-times-circle"></app-icon>
                                        {{ 'GSE inactive'|i18n }}
                                    </div>
                                </ng-container>
                                <app-icon *ngIf="!isDefined(relation.start_date) && isDefined(community?.activation_date)"
                                          icon-color-w name="fas-exclamation-triangle"
                                          [title]="'Missing activation date'|i18n">
                                </app-icon>
                            </div>
                        </div>
                    </div>
                    <div class="mt-12 ml-16" fxLayout="row" fxLayoutGap="4px">
                        <span class="field-name">{{ 'Address'|i18n }}:</span>
                        <span>{{ addressToString(pod.address)|i18n }}</span>
                    </div>
                    <div *ngIf="pod.has_wifi" class="mt-12 ml-16" fxLayout="row" fxLayoutGap="4px">
                        <span class="field-name">{{ 'Wi-Fi'|i18n }}:</span>
                        <span>{{ (pod.has_wifi ? 'Yes' : 'No')|i18n }}</span>
                    </div>
                    <div *ngIf="pod.energy_provider" class="mt-12 ml-16" fxLayout="row" fxLayoutGap="4px">
                        <span class="field-name">{{ 'Energy supplier'|i18n }}:</span>
                        <span>{{ pod.energy_provider|i18n }}</span>
                    </div>
                    <div *ngIf="pod.creation_type" class="mt-12 ml-16" fxLayout="row" fxLayoutGap="4px">
                        <span class="field-name">{{ 'Creation type'|i18n }}:</span>
                        <span>{{ pod.creation_type|genericPipe }}</span>
                    </div>
                    <div *ngIf="pod.substation" class="mt-12 ml-16" fxLayout="row" fxLayoutGap="4px">
                        <span class="field-name">{{ 'Substation code'|i18n }}:</span>
                        <span>{{ pod.substation }}</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- member details middle column -->
        <div fxLayout="column" fxLayoutGap="30px">
            <div fxLayout="row" fxLayoutGap="4px">
                <span class="field-name">{{ 'Juridical type'|i18n }}:</span>
                <span>{{ member.juridical_type|ecMemberJuridicalType|i18n }}</span>
            </div>
            <div *ngIf="member.legal_form as legalForm" fxLayout="row" fxLayoutGap="4px">
                <span class="field-name">{{ 'Legal form'|i18n }}:</span>
                <span>{{ legalForm|ecMemberLegalFormType|i18n }}</span>
            </div>
            <div *ngIf="member.subject_type as subjectType" fxLayout="row" fxLayoutGap="4px">
                <span class="field-name">{{ 'Subject type'|i18n }}:</span>
                <span>{{ subjectType|ecMemberSubjectType|i18n }}</span>
            </div>
            <div *ngIf="member.entity_subtype as entitySubtype" fxLayout="row" fxLayoutGap="4px">
                <span class="field-name">{{ 'Entity subtype'|i18n }}:</span>
                <span>{{ entitySubtype|ecMemberEntitySubtype|i18n }}</span>
            </div>
            <div *ngIf="mkAddress() as address" fxLayout="row" fxLayoutGap="4px">
                <span class="field-name">
                    {{
                        (!(member.juridical_type === ECJuridicalType.INDIVIDUAL && member.legal_form === ECLegalForm.OTHER_INDIVIDUALS) ?
                            'Registered office address' : 'Residential address')|i18n
                    }}:
                </span>
                <span>{{ address }}</span>
            </div>
            <div *ngIf="member.personal_data?.birth_date" fxLayout="row" fxLayoutGap="4px">
                <span class="field-name">
                    {{ (member.juridical_type === ECJuridicalType.CORPORATE_ENTITY ? 'Signatory\'s birth date' : 'Birth date')|i18n }}:
                </span>
                <span>{{ member.personal_data.birth_date|i18nDate }}</span>
            </div>
            <div *ngIf="member.personal_data?.birth_country" fxLayout="row" fxLayoutGap="4px">
                <span class="field-name">
                    {{ (member.juridical_type === ECJuridicalType.CORPORATE_ENTITY ? 'Signatory\'s birth country' : 'Birth country')|i18n }}
                    :
                </span>
                <span>{{ getCountryName(member.personal_data.birth_country) }}</span>
            </div>
            <div *ngIf="member.personal_data?.birth_municipality" fxLayout="row" fxLayoutGap="4px">
                <span class="field-name">
                    {{ (member.juridical_type === ECJuridicalType.CORPORATE_ENTITY ? 'Signatory\'s birth municipality' : 'Birth municipality')|i18n }}
                    :
                </span>
                <span>{{ member.personal_data.birth_municipality }}</span>
            </div>
            <div *ngIf="member.personal_data?.ateco_code" fxLayout="row" fxLayoutGap="4px">
                <span class="field-name">
                    {{ 'ATECO code'|i18n }}:
                </span>
                <span>{{ member.personal_data.ateco_code }}</span>
            </div>
            <div *ngIf="member.signatory_tax_code" fxLayout="row" fxLayoutGap="4px">
                <span class="field-name">
                    {{ 'Signatory\'s tax code'|i18n }}:
                </span>
                <span>{{ member.signatory_tax_code }}</span>
            </div>
            <div *ngIf="member.personal_data?.mobile_number as mobile" fxLayout="row" fxLayoutGap="4px">
                <span class="field-name">{{ 'Mobile'|i18n }}:</span>
                <span>{{ mobile }}</span>
            </div>
            <div *ngIf="member.personal_data?.telephone_number as phone" fxLayout="row" fxLayoutGap="4px">
                <span class="field-name">{{ 'Telephone'|i18n }}:</span>
                <span>{{ phone }}</span>
            </div>
            <div *ngIf="member.personal_data?.email as email"
                 fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
                <div fxLayout="row" fxLayoutGap="4px">
                    <span class="field-name">{{ 'Email'|i18n }}:</span>
                    <span>{{ email }}</span>
                </div>
                <a [href]="'mailto:'+email" class="email-anchor">
                    <button app-small-ghost-button>
                        <app-icon name="fal-envelope"></app-icon>
                        {{ 'Contact'|i18n }}
                    </button>
                </a>
                <button *ngIf="canBeInvited"
                        app-small-ghost-button
                        (click)="onClickSendInvitation(true)"
                        [disabled]="memberIsOwnerOnly() || !canUpdate">
                    <app-icon name="fal-paper-plane"></app-icon>
                    {{ 'Send invitation'|i18n }}
                </button>
            </div>
            <div *ngIf="memberIsOwnerOnly() && canBeInvited">
                <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="30px" economics-warning fxFlex="40">
                    <app-icon icon-color-w name="fas-info-circle"></app-icon>
                    <div>{{ 'Since this member is not a holder of any POD, he cannot see data in the app. Therefore, neither registration nor access to any app is provided.'|i18n }}</div>
                </div>
            </div>
            <div *ngIf="member.personal_data?.pec as pec"
                 fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
                <div fxLayout="row" fxLayoutGap="4px">
                    <span class="field-name">{{ 'PEC'|i18n }}:</span>
                    <span>{{ pec }}</span>
                </div>
                <a [href]="'mailto:'+pec" class="email-anchor">
                    <button app-small-ghost-button>
                        <app-icon name="fal-envelope"></app-icon>
                        {{ 'Contact'|i18n }}
                    </button>
                </a>
            </div>
            <div *ngIf="member.personal_data?.piva as piva" fxLayout="row" fxLayoutGap="4px">
                <span class="field-name">{{ 'P. iva'|i18n }}:</span>
                <span>{{ piva }}</span>
            </div>
            <div *ngIf="member.personal_data?.cf as cf" fxLayout="row" fxLayoutGap="4px">
                <span class="field-name">{{ 'CF'|i18n }}:</span>
                <span>{{ cf }}</span>
            </div>
            <div *ngIf="member.personal_data?.iban as iban" fxLayout="row" fxLayoutGap="4px">
                <span class="field-name">{{ 'IBAN'|i18n }}:</span>
                <span>{{ iban }}</span>
            </div>
            <div *ngIf="memberIsBarelyOwner() && member.personal_data?.upselling_pod as upselling_pod" fxLayout="row" fxLayoutGap="4px">
                <span class="field-name">{{ 'Upselling POD code'|i18n }}:</span>
                <span>{{ upselling_pod }}</span>
            </div>
            <div *ngIf="memberIsBarelyOwner() && member.personal_data?.supply_address as supply_address" fxLayout="row" fxLayoutGap="4px">
                <span class="field-name">{{ 'Supply address'|i18n }}:</span>
                <span>{{ supply_address }}</span>
            </div>
            <div *ngFor="let doc of member.documents" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="12px">
                <div fxLayout="row" fxLayoutGap="4px">
                    <span class="field-name">{{ doc.document_type|ecDocumentTypeI18n }}:</span>
                    <span>{{ doc.filename || '--'|i18n }}</span>
                </div>
                <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="4px">
                    <span class="size-mb">{{ prettySize(doc.size) }}</span>
                    <button *ngIf="hasFile(doc)" app-small-ghost-button (click)="onClickDownloadDocument(doc)">
                        <app-icon name="fal-file"></app-icon>
                        {{ 'Open file'|i18n }}
                    </button>
                </div>
            </div>
        </div>

        <!-- member details right column -->
        <div fxLayout="column" fxLayoutGap="30px" fxFlex>
            <div *ngIf="isDefined(member.updated_at)" fxLayout="row" fxLayoutGap="4px">
                <span class="field-name">{{ 'Last update'|i18n }}:</span>
                <span>{{ member.updated_at|i18nDate }}</span>
            </div>
            <ng-container *appVar="getAcceptedDocuments(member) as acceptedDocs">
                <div *ngIf="acceptedDocs.length > 0" fxLayout="column">
                    <div class="field-name mb-10">{{ 'Consents'|i18n }}:</div>
                    <div *ngFor="let doc of acceptedDocs">
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                            <app-icon *ngIf="doc.accepted" name="fal-check-circle" class="tick-icon"></app-icon>
                            <app-icon *ngIf="!doc.accepted" name="fal-times-circle" class="cross-icon"></app-icon>
                            <a href="javascript:void(0);" rel="noopener noreferrer" (click)="onClickDownloadAcceptedDocument(doc.id)">
                                {{ doc.name }}
                            </a>
                        </div>
                    </div>
                </div>
            </ng-container>
            <!-- Subject notes -->
            <div *ngIf="!!notes" fxLayout="column" class="note-panel" fxLayoutGap="16px">
                <div fxLayout="row" fxLayoutAlign="space-between center">
                    <div class="field-name">{{ 'Notes'|i18n }}</div>
                    <button app-icon-button [disabled]="!canUpdate"
                            [title]="'Edit subject notes'|i18n"
                            (click)="onClickEditSubjectNotes()">
                        <app-icon name="fal-pencil-alt"></app-icon>
                    </button>
                </div>
                <div class="notes-content">{{ clipText(notes.content || '') }}</div>
                <div fxLayout="row" fxLayoutAlign="end" class="notes-user" *ngIf="notesInfo as ni">
                    <span>{{ 'Last update'|i18n }}: {{ ni.updatedAt|i18nDate }}, {{ ni.userName }}</span>
                </div>
            </div>
            <div *ngIf="!notes">
                <button app-small-ghost-button [disabled]="!canUpdate"
                        (click)="onClickEditSubjectNotes()">
                    <app-icon name="fal-pencil-alt"></app-icon>
                    {{ 'Add notes'|i18n }}
                </button>
            </div>
        </div>
    </div>

    <!-- account management -->
    <div fxLayout="row" *ngIf="!!account" class="pod-panel mt-52">
        <div fxLayout="column" fxFlex>
            <div class="field-name">{{ 'Account management'|i18n }}</div>
            <div fxLayout="row" fxLayoutAlign="start center">
                <div fxLayout="column">
                    <div *ngIf="account.enabled" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px" class="mt-20 ml-16">
                        <div fxLayout="row" fxLayoutGap="4px">
                            <span class="field-name">{{ 'User account status'|i18n }}:</span>
                            <span>{{ 'Enabled'|i18n }}</span>
                        </div>
                        <button app-small-ghost-button [disabled]="!canDisable" (click)="onClickDisableAccount()">
                            <app-icon name="fal-user-slash"></app-icon>
                            {{ 'Disable user'|i18n }}
                        </button>
                        <button app-small-ghost-button
                                [title]="'Delete associated user'|i18n"
                                (click)="onClickDeleteMemberUser()"
                                [disabled]="!canDelete"
                                class="ml-16">
                            <app-icon name="fal-trash-alt"></app-icon>
                            {{ 'Delete user'|i18n }}
                        </button>
                    </div>
                    <div class="mt-20 ml-16" fxLayout="row" fxLayoutGap="4px">
                        <span class="field-name">{{ 'Last access on'|i18n }}:</span>
                        <span>{{ isDefined(account.lastAccessOn) ? (account.lastAccessOn|i18nDate) : '--/--/--' }}</span>
                    </div>
                    <div *ngIf="!account.enabled" fxLayout="row" fxLayoutAlign="start center" class="mt-20 ml-16">
                        <div fxLayout="row" fxLayoutAlign="center center"
                             fxLayoutGap="20px" class="warning-panel">
                            <div fxLayout="row" fxLayoutAlign="start center">
                                <app-icon name="fas-info-circle" class="warning-icon"></app-icon>
                            </div>
                            <div>{{ mkDisableReasonMessage(account.disableReason)|i18n }}</div>
                            <button app-small-ghost-button [disabled]="!canEnable" (click)="onClickReactivateAccount()">
                                <app-icon name="fal-user-check"></app-icon>
                                {{ 'Re-enable user'|i18n }}
                            </button>
                            <button app-small-ghost-button
                                    [title]="'Delete associated user'|i18n"
                                    (click)="onClickDeleteMemberUser()"
                                    [disabled]="!canDelete"
                                    class="ml-16">
                                <app-icon name="fal-trash-alt"></app-icon>
                                {{ 'Delete user'|i18n }}
                            </button>
                        </div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="start center" class="mt-20 ml-16">
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
                            <app-icon *ngIf="isPasswordOk(account)" name="fal-check-circle"
                                      class="tick-icon"></app-icon>
                            <app-icon *ngIf="!isPasswordOk(account)" name="fal-times" class="cross-icon"></app-icon>
                            <div>{{ 'Regular password status'|i18n }}</div>
                        </div>
                        <div class="ml-16" fxLayout="row" fxLayoutGap="4px">
                            <span class="field-name">{{ 'PW expiration'|i18n }}:</span>
                            <span>{{ account.pwExpiresOn|i18nDate }}</span>
                        </div>
                        <button app-small-ghost-button [title]="'Force password change'|i18n" class="ml-16"
                                [disabled]="!canRenewPassword"
                                (click)="onClickForcePwdChange()">
                            <app-icon name="fal-lock"></app-icon>
                            {{ 'Force PW change'|i18n }}
                        </button>
                    </div>
                </div>
                <div fxFlex="15"></div>
                <div fxLayout="column">
                    <div *ngIf="show2fa" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px"
                         class="mt-20 ml-16">
                        <app-icon *ngIf="account.mandatory2fa" name="fal-check-circle" class="tick-icon"></app-icon>
                        <app-icon *ngIf="!account.mandatory2fa" name="fal-times" class="cross-icon"></app-icon>
                        <div>{{ '2FA mandatory'|i18n }}</div>
                    </div>
                    <div *ngIf="show2fa" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px"
                         class="mt-20 ml-16">
                        <app-icon *ngIf="account.enabled2fa" name="fal-check-circle" class="tick-icon"></app-icon>
                        <app-icon *ngIf="!account.enabled2fa" name="fal-times" class="cross-icon"></app-icon>
                        <div>{{ '2FA in use'|i18n }}</div>
                        <button app-small-ghost-button [title]="'Reset 2FA'|i18n" class="ml-30"
                                [disabled]="!canReset2FA"
                                (click)="onClickReset2FA()">
                            <app-icon name="fal-shield-alt"></app-icon>
                            {{ 'Reset 2FA'|i18n }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #spinner let-data="data" let-close="close">
    <app-spinner [spinnerDataSubj]="data" (closeSpinner)="close()"></app-spinner>
</ng-template>
